import type { ValueEvent } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/client/design/components/cr-delete-button.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import { ChromiumSnackbar } from '@chancenwerk/client/design/components/cr-snackbar.js';
import { WorkshopAppointment } from '@chancenwerk/shared/workshops/entities/WorkshopAppointment.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { DateTime } from 'luxon';
import '../akademie-component-workshop-appointment-edit.js';

@customElement('akademie-dialog-workshop-appointment-edit')
export class AkademieDialogWorkshopAppointmentEdit extends ChromiumDialog<WorkshopAppointment> {
  static override get element_name() {
    return 'akademie-dialog-workshop-appointment-edit';
  }

  override heading?: string | undefined = 'Workshop Termin bearbeiten';

  @property({ attribute: false }) workshopID = new RXController(this, '');
  @property({ attribute: false }) workshopAppointment = new RXController(
    this,
    new WorkshopAppointment({
      start: DateTime.now().set({ minute: 0 }).toJSDate(),
      end: DateTime.now().set({ minute: 0 }).plus({ hours: 1 }).toJSDate(),
    }),
  );

  override content() {
    return html`<akademie-component-workshop-appointment-edit
      ${css({ minWidth: '600px' })}
      .workshopID=${this.workshopID.value}
      .workshopAppointment=${this.workshopAppointment.value}
      @saved=${(e: ValueEvent<WorkshopAppointment>) => this._saved(e)}
      @error=${(e: any) => ChromiumSnackbar.show(e.detail.message as string)}
    ></akademie-component-workshop-appointment-edit>`;
  }

  private async _saved(e: ValueEvent<WorkshopAppointment>) {
    await this.close(e.detail.value);
  }
}
